import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const L = ({ children }) => <Label className="text-xs text-slate-500">{children}</Label>;

export function RentalFields({ quoteType, rental, onChange, editable, testPrefix = "" }) {
  const p = testPrefix;
  const r = rental || {};
  const set = (patch) => onChange({ ...r, ...patch });
  return (
    <div className="rounded-md border border-sky-100 bg-sky-50/40 p-3 space-y-3" data-testid={`${p}rental-fields`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div><L>Lock-in term (months)</L><Input type="number" min="1" value={r.lock_in_months ?? 36} disabled={!editable} onChange={(e) => set({ lock_in_months: e.target.value })} className="mt-1" data-testid={`${p}rental-lockin`} /></div>
        <div>
          <L>Security deposit (months of rent)</L>
          <Input type="number" min="0" step="0.5" value={r.deposit_months ?? 3} disabled={!editable} onChange={(e) => set({ deposit_months: e.target.value })} className="mt-1" data-testid={`${p}rental-deposit`} />
          <div className="text-[11px] text-slate-500 mt-1">PDF shows: "{Number(r.deposit_months ?? 3)} months rent as refundable deposit"</div>
        </div>
      </div>
      <div><L>Included in the rental price</L><Input value={r.included ?? ""} disabled={!editable} onChange={(e) => set({ included: e.target.value })} className="mt-1" data-testid={`${p}rental-included`} /></div>
      {quoteType === "rental_buy" && (
        <div data-testid={`${p}buy-option`}>
          <L>Buy option</L>
          <div className="mt-1 space-y-2 text-sm text-slate-700">
            <label className="flex items-start gap-2">
              <input type="radio" checked={(r.buy_option || "transfer_1") === "transfer_1"} disabled={!editable} onChange={() => set({ buy_option: "transfer_1" })} className="mt-1" data-testid={`${p}buy-transfer-1`} />
              Ownership transfers to the client at the end of the lock-in term for ₹1
            </label>
            <label className="flex items-start gap-2">
              <input type="radio" checked={r.buy_option === "purchase"} disabled={!editable} onChange={() => set({ buy_option: "purchase" })} className="mt-1" data-testid={`${p}buy-purchase`} />
              <span className="flex flex-wrap items-center gap-1.5">Client may purchase the machine at the end of the lock-in term for ₹
                <Input type="number" min="0" value={r.buy_amount ?? ""} disabled={!editable || r.buy_option !== "purchase"} onChange={(e) => set({ buy_amount: e.target.value })} className="w-36 h-8" data-testid={`${p}buy-amount`} />
              </span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
}
